import NextImage from '@react/shared/components/Image';
import React from 'react';
import slugify from 'slugify';
import staticPages from 'sly/../static-pages.json';
import { assetPath } from 'sly/lib/path';
import { usePrefetch } from 'sly/services/api';
import {
  SitemapLayout,
  SitemapLink,
  SitemapLinkWrapper,
} from 'sly/sitemap/components/SitemapSharedComponents';
import {
  SITEMAP_STATIC_PAGES_BREADCRUMB_ITEMS,
  staticPagesPathsWithLabel,
} from 'sly/sitemap/constants';
import { Heading } from 'sly/system';

const StaticPages = () => {
  const {
    requestInfo: { response: hubPages, hasFinished: hubHasFinished },
  } = usePrefetch('getHubPage');
  const {
    requestInfo: {
      response: marketingPages,
      hasFinished: marketingHasFinished,
    },
  } = usePrefetch('getMarketingPage');

  if (!hubHasFinished || !marketingHasFinished) {
    return (
      <div
        className='flex h-screen items-center justify-center'
        data-tp-id='gen-div-e49b6ac5-3eda-4e91-b54c-9724e5472f75'
      >
        <NextImage
          width='1'
          height='1'
          alt=''
          src={assetPath('uploads/react-assets/homebase/loader.svg')}
        />
      </div>
    );
  }

  return (
    <SitemapLayout
      headTitle='Static Pages Site Map | Seniorly'
      breadcrumbItems={SITEMAP_STATIC_PAGES_BREADCRUMB_ITEMS}
      metaDescription='Seniorly Sitemap of important topic pages'
    >
      <Heading
        as='h2'
        className='mb-6'
        data-tp-id='gen-Heading-2c89d391-f7af-46ea-b01d-bd6b05099c0a'
      >
        Static pages
      </Heading>

      <SitemapLinkWrapper>
        {staticPagesPathsWithLabel.map(({ label, path }) => {
          return (
            <SitemapLink key={label} href={path}>
              {label}
            </SitemapLink>
          );
        })}
      </SitemapLinkWrapper>

      <Heading
        as='h4'
        font='font-t-m'
        className='mb-6'
        data-tp-id='gen-Heading-4cf41bfb-ec11-434a-ba86-ebdd3befc9a5'
      >
        Marketing pages
      </Heading>

      <SitemapLinkWrapper>
        {marketingPages?.data
          ?.filter(({ slug }) => staticPages.cmsMarketingTypes.includes(slug))
          .map(({ slug, title }) => {
            return (
              <SitemapLink
                key={slug}
                href={`/company/${slugify(slug, { lower: true })}`}
              >
                {title}
              </SitemapLink>
            );
          })}
        <SitemapLink href='/company/about'>About Seniorly</SitemapLink>
      </SitemapLinkWrapper>

      <Heading
        as='h4'
        font='font-t-m'
        className='mb-6'
        data-tp-id='gen-Heading-782080c0-fea6-48ec-86c7-6ddc13d433a1'
      >
        Hub pages
      </Heading>
      <SitemapLinkWrapper>
        {hubPages?.data
          ?.filter(({ slug }) => staticPages.cmsHubTypes.includes(slug))
          .map(({ slug, title }) => {
            return (
              <SitemapLink
                key={slug}
                href={`/${slugify(slug, { lower: true })}`}
              >
                {title}
              </SitemapLink>
            );
          })}
      </SitemapLinkWrapper>
    </SitemapLayout>
  );
};

export default StaticPages;
